import { WHATSAPP_DEFAULT_MESSAGE } from "@/config/siteConfig";
import { waLink, trackEvent } from "@/lib/whatsapp";
import { Reveal } from "@/components/Reveal";
import { WhatsAppIcon } from "@/components/WhatsAppIcon";

const STEPS = [
  {
    title: "Choisissez votre offre",
    description: "Parcourez nos forfaits et repérez celui qui correspond à vos besoins.",
  },
  {
    title: "Contactez-nous sur WhatsApp",
    description: "Un clic sur « Je suis intéressé » ouvre WhatsApp avec un message déjà préparé.",
  },
  {
    title: "Un conseiller vous accompagne",
    description: "Une vraie personne répond à vos questions et finalise tout avec vous.",
  },
];

export const HowItWorks = () => (
  <section id="etapes" className="border-t border-black/5 bg-gray-50 py-24 md:py-32" data-testid="how-it-works-section">
    <div className="mx-auto max-w-7xl px-4 md:px-8">
      <Reveal className="mb-16 max-w-2xl">
        <p className="mb-3 font-display text-xs font-bold uppercase tracking-[0.3em] text-gray-400">04 — Comment ça fonctionne</p>
        <h2 className="font-display text-3xl font-extrabold tracking-tight text-black sm:text-4xl lg:text-5xl">
          Trois étapes, c'est tout
        </h2>
      </Reveal>

      <div className="grid gap-12 md:grid-cols-3 md:gap-8">
        {STEPS.map((step, i) => (
          <Reveal key={step.title} delay={i * 0.14}>
            <div className="relative" data-testid={`step-${i + 1}`}>
              <span className="pointer-events-none absolute -top-10 left-0 -z-0 select-none font-display text-8xl font-extrabold text-gray-200 md:text-9xl" aria-hidden="true">
                {String(i + 1).padStart(2, "0")}
              </span>
              <div className="relative z-10 pt-12">
                <h3 className="font-display text-xl font-bold text-black">{step.title}</h3>
                <p className="mt-3 max-w-xs text-base text-gray-600">{step.description}</p>
              </div>
            </div>
          </Reveal>
        ))}
      </div>

      <Reveal delay={0.2} className="mt-16 text-center">
        <a
          href={waLink(WHATSAPP_DEFAULT_MESSAGE)}
          target="_blank"
          rel="noopener noreferrer"
          onClick={() => trackEvent("clic_whatsapp", { source: "etapes" })}
          data-testid="how-it-works-whatsapp-cta"
          className="inline-flex h-14 items-center gap-2.5 rounded-full bg-black px-9 text-base font-bold text-white transition-colors duration-300 hover:bg-gray-800"
        >
          <WhatsAppIcon className="h-5 w-5 text-jeem-yellow" />
          Commencer maintenant sur WhatsApp
        </a>
      </Reveal>
    </div>
  </section>
);
